import {  m } from 'framer-motion';
import React from 'react'
import { Box, Container, Grid, Stack, Typography, } from '@mui/material'
import Rating from '@mui/material/Rating';
import Carousel, { useCarousel, CarouselDots, CarouselArrows } from '../carousel';
import './homepage.css'
import { useResponsive } from "../../hooks/use-responsive";
import { MotionViewport,  varFade,  } from '../animate';

const carouselData = [
    {
        quote: "I love how easy MegaConnect is! My kids can use their cloud computer on my laptop, and they can’t close the app without my permission. If I need to use the laptop, I can take control and use it myself. It’s perfect for keeping kids safe and giving parents control!",
        rating: 4.5,
        name: "Sangayya Hiremath",
        // role: "PARENT",
    },
    {
        quote: "MegaConnect has made it so much easier for me to keep my child safe online. Before, managing what my child could access was really stressful. With MegaConnect, I can easily block adult websites and monitor their activity from anywhere. Now, I feel confident knowing my child is exploring the internet safely. I highly recommend it to other parents!",
        rating: 5,
        name: "Gautam Jain",
        // role: "PARENT",
    },
    {
        quote: "As a parent, keeping my kids safe online is a top priority, and MegaConnect delivers! The app's ability to block adult and fraudulent sites, while letting me control screen time, has made a huge difference. It's fast, secure, and perfect for busy parents!",
        rating: 4,
        name: "Pramod Kothari",
        // role: "PARENT",
    },
    {
        quote: "As a parent of two, MegaConnect has been a game-changer! It gives me peace of mind with its secure Virtual Computer , letting me monitor and limit screen time easily. Plus, knowing all adult and fraudulent sites are blocked is a huge relief. Highly recommend it to all parents!",
        rating: 4.5,
        name: "Manju Devi",
        // role: "PARENT",
    },
];

// Rating Component to display stars


export default function HomeTestimonial() {
    const mdUp = useResponsive("up", "md");
    const carousel = useCarousel({
        autoplay: true,
        ...CarouselDots({
            rounded: true,
        }),
        slidesToShow: 3,
        // centerMode: true,
        centerPadding: '80px',
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2, },
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 1 },
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1, centerPadding: '0' },
            },
        ],
    });


    return (
        <Container maxWidth={false} sx={{
            pb:{xs:15 ,md:10 }, mb: 3, mt: { xs: 5 }, zIndex: -2, pt:{xs:10,md:0},
            backgroundImage: 'url("/assets/Testimonial_background.svg")', // Replace with the actual image URL
            backgroundSize: "cover", // Adjust as needed
            backgroundPosition: "center", // Adjust as needed
            bgcolor: '#F1F1F1',
            borderRadius:5,
        }}
        component={MotionViewport} 
         >

            <Grid spacing={2} alignItems="center" sx={{ pt: { xs: 8 } }} >


                {mdUp && <Typography variant="h2" marginBottom={1} className="heading3"
                component={m.div}
                variants={varFade({ distance: 120, durationIn: 0.9,  }).inRight}
                    textAlign='center'  gutterBottom>
                    HEAR FROM OUR
                    <span style={{ color: '#1E53E8', }} > CUSTOMERS </span>
                </Typography>}
                {!mdUp &&
                    <Typography variant="h4" marginBottom={1} className="heading3"
                        textAlign='center' component="P" gutterBottom>
                        HEAR FROM OUR
                        <span style={{ color: '#1E53E8', }} > CUSTOMERS </span>
                    </Typography>
                }
                {mdUp && <Typography sx={{ fontSize: '18px' }} className="heroTxt" textAlign='center'  component={m.div}
                variants={varFade({ distance: 120, durationIn: 0.9,  }).inLeft} gutterBottom>
                    See Why Customers Choose MegaConnect
                </Typography>}
                {!mdUp && <Typography variant="body1" className="heroTxt" textAlign='center' gutterBottom>
                    See Why Customers Choose MegaConnect
                </Typography>}
            </Grid>
            <Box
                sx={{
                    overflow: 'hidden',
                    position: 'relative',

                }}
                component={m.div}
                variants={varFade({ distance: 120, durationIn: 0.9,  }).inUp}
            >
                <CarouselArrows shape="rounded" onNext={carousel.onNext} onPrev={carousel.onPrev}>
                    <Carousel ref={carousel.carouselRef} {...carousel.carouselSettings}>
                        {carouselData.map((item, index) => (
                            <Stack key={index} sx={{ mt: 3,pt:{xs:3 } ,mb: 2 }}  >
                                <Box sx={{ px: 2, textAlign: 'center' }}>
                                    <Typography sx={{
                                        fontSize: 18,
                                        fontFamily: 'Roboto Flex',
                                        fontWeight: '500',
                                        lineHeight: 1.5,
                                        wordWrap: 'break-word',
                                        justifyContent: 'center',
                                        textAlign: 'center'
                                    }} >
                                        "{item.quote}"
                                    </Typography>
                                    <Rating name="read-only" value={item.rating}   precision={0.1}  readOnly sx={{ mt: 3 }} />
                                    <Typography variant="h6" sx={{
                                        color: '#1D53E7',
                                        fontSize: 22,
                                        fontFamily: 'Roboto Flex',
                                        fontStyle: 'italic',
                                        fontWeight: '700',
                                        wordWrap: 'break-word',
                                        mt: 2
                                    }}>
                                        {item.name}
                                    </Typography>
                                    {/* <Typography sx={{
                                        color: 'black',
                                        fontSize: 16,
                                        fontFamily: 'Roboto Flex',
                                        fontWeight: '550',
                                        textTransform: 'uppercase',
                                        wordWrap: 'break-word',
                                        justifyContent: 'center',
                                        textAlign: 'center'
                                    }}>
                                        {item.role}
                                    </Typography> */}
                                </Box>
                            </Stack>
                        ))}
                    </Carousel>
                </CarouselArrows>
            </Box>

        </Container>
    )
}
